import type {
  CatalogFilterType,
  CatalogListResponse,
  CatalogParentItem,
} from "../types/catalog";

/**
 * Mock aligned with trendy-catalog-service GET /api/v1/catalog/list response.
 * Examples from api-trendy-catalog-service.pdf (items 2216 and 3000).
 * Used when REACT_APP_USE_CATALOG_MOCK=true.
 */

const MOCK_CATALOG: CatalogParentItem[] = [
  {
    itemId: "2216",
    manufactureCode: "LAB-MAT-2216",
    nameProduct: "Labial Mate",
    productIdVtex: 123456,
    variationCount: 3,
    variationsSynced: 2,
    variationsMissing: 1,
    hasDuplicateProduct: false,
    statusCatalog: "PARTIAL",
    lastSyncDate: "2026-06-18T14:30:00",
    variations: [
      {
        refId: "TONE-A",
        manufactureCode: "LAB-MAT-2216-A",
        nameProduct: "Labial Mate — Tono A",
        skuIdVtex: 9001,
        productIdVtex: 123456,
        statusCatalog: "OK",
        lastSyncDate: "2026-06-10T09:00:00",
      },
      {
        refId: "TONE-B",
        manufactureCode: "LAB-MAT-2216-B",
        nameProduct: "Labial Mate — Tono B",
        skuIdVtex: 9002,
        productIdVtex: 123456,
        statusCatalog: "OK",
        lastSyncDate: "2026-06-10T09:00:00",
      },
      {
        refId: "TONE-C",
        manufactureCode: "LAB-MAT-2216-C",
        nameProduct: "Labial Mate — Tono C",
        skuIdVtex: null,
        productIdVtex: null,
        statusCatalog: "SKU_MISSING",
        lastSyncDate: null,
      },
    ],
  },
  {
    itemId: "3000",
    manufactureCode: "SIESA-3000",
    nameProduct: "Producto SIESA",
    productIdVtex: 789012,
    variationCount: 1,
    variationsSynced: 1,
    variationsMissing: 0,
    hasDuplicateProduct: false,
    statusCatalog: "OK",
    lastSyncDate: "2026-06-15T11:00:00",
    variations: [
      {
        refId: "SIESA-3000-STD",
        manufactureCode: "SIESA-3000",
        nameProduct: "Producto SIESA",
        skuIdVtex: 9500,
        productIdVtex: 789012,
        statusCatalog: "OK",
        lastSyncDate: "2026-06-15T11:00:00",
      },
    ],
  },
];

const matchesSearch = (
  product: CatalogParentItem,
  search: string,
  filterType?: CatalogFilterType
): boolean => {
  const term = search.toLowerCase().trim();
  if (!term) return true;

  switch (filterType) {
    case "MANUFACTURE_CODE":
      return (
        product.itemId.toLowerCase().includes(term) ||
        product.manufactureCode.toLowerCase().includes(term)
      );
    case "NAME_PRODUCT":
      return product.nameProduct.toLowerCase().includes(term);
    case "PRODUCT_ID_VTEX":
      return product.productIdVtex != null && String(product.productIdVtex).includes(term);
    default:
      return (
        product.itemId.toLowerCase().includes(term) ||
        product.nameProduct.toLowerCase().includes(term) ||
        product.manufactureCode.toLowerCase().includes(term) ||
        (product.productIdVtex != null &&
          String(product.productIdVtex).includes(term))
      );
  }
};

export const fetchCatalogMock = (
  page: number,
  size: number,
  search = "",
  filterType?: CatalogFilterType
): CatalogListResponse => {
  const filtered = MOCK_CATALOG.filter((p) =>
    matchesSearch(p, search, filterType)
  );
  const start = (page - 1) * size;
  const content = filtered.slice(start, start + size);
  const totalPages = Math.ceil(filtered.length / size) || 0;

  return {
    content,
    totalElements: filtered.length,
    totalPages,
    currentPage: page,
    pageSize: size,
    paginationMode: "BY_PARENT",
  };
};
